import React, { useEffect, useState, useRef, useMemo } from "react";
import styled from "styled-components";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { ReactComponent as Alert } from "../../assets/images/alert1.svg";
import {
  Badge,
  Button,
  Col,
  Modal,
  Row,
  Avatar,
  Checkbox,
  Popover,
  Tooltip,
  Space,
  Form,
  message,
  Spin,
  Upload,
  Select,
} from "antd";
import { CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import {
  ButtonFilled,
  ButtonOutlined,
  Buttontransparent,
} from "../../Reusablecomponents/UIButtons";
import { StyledTable } from "../../Reusablecomponents/UITable/UITable";
import { ReactComponent as EditIcon } from "../../assets/images/Editicon.svg";
import { ReactComponent as DeleteIcon } from "../../assets/images/delete-icon.svg";
import FilterIcon from "../../assets/images/Filter-Icon.svg";
import SortIcon from "../../assets/images/sort-svgrepo-com.svg";
import ImportIcon from "../../assets/images/download1.svg";
import ExportIcon from "../../assets/images/export-svgrepo-com (1).svg";
import GridBuilder from "../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../Reusablecomponents/ReusableDrawer";
import UIModal from "../../Reusablecomponents/UIModal";
import FuelDetails from "../../containers/TrackRightAI/fuelEntryDetailsAI";
import { CALL_API } from "../../Common/api";
import { useSelector } from "react-redux";
import moment from "moment";
import dayjs from "dayjs";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";
import { CSVLink } from "react-csv";
import axios from "axios";
import BulkDeletePopup from "../../components/Popup/BulkDeletePopup";
import ConfirmModal from "../../components/Popup/ConfirmModal";
import { CustomCheckbox } from "../../Reusablecomponents/UIButtons";

const WideButton = styled(ButtonFilled)`
  width: 200px; /* Adjust the width as needed */
`;

export const WrapperBox = styled.div`
  background-color: white;
  padding: 15px;
  border-radius: 8px;
  .consingment_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #5f6d8c;
    font-weight: 400;
    font-size: 16px;
    line-height: 19.36px;
  }
  .FilterIcon {
    width: 38px;
    height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    // border-radius:50%;
    background-color: #ebf7ed !important;
    margin-left: 10px;
  }

  @media (max-width: 320px) {
    .consingment_container {
      display: flex;
      align-items: center;
      flex-direction: column;
      color: #5f6d8c;
    }
    .consingment_container_two {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 0px 08px 0px;
    }
    .ant-tabs-nav .ant-tabs-nav-list {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin: 20px 0px 08px 0px;
    }
  }
  .consingment_container_two {
    display: flex;
    align-items: center;
  }
  p {
    margin-bottom: 0px;
    line-height: 0px;
    font-size: 16px;
    font-weight: 400;
  }
  .Create_btn {
    width: 150;
    height: 38;
    gap: 8px;
    border-width: 1px;
    border: none;
    outline: none;
    border-radius: 26px;
    padding: 9px 16px;
    font-weight: 500;
    font-size: 16px;
    background-color: rgb(44, 150, 61) !important;
    color: white !important;
  }

  .Creating_Consignment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px 0px 10px 0px;
    border-bottom: 1px solid rgb(231 231, 237);
    padding: 8px 7px 15px 8px;
  }
  .ant-badge.ant-badge-status .ant-badge-status-dot {
    width: 12px;
    height: 12px;
  }
  .badg {
    padding: 6px;
  }

  .modal_container_forfiltermenu {
    display: flex;
    justify-content: space-between;
    margin: 7px 14px 7px 0px;
  }
  .flilter_five {
    font-weight: 500;
    font-size: 20px;
    line-height: 24.2px;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .checkbox_group_container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .import_modal {
    margin: 18px 0px 10px 0px;
    background-color: yellow;
  }
  .formodalimport {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px 0px 10px 0px;
    border-bottom: 1px solid rgb(231 231, 237);
    padding: 8px 7px 15px 8px;
  }
  .dashedbtn {
    border: 2px dashed black;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    padding: 75px 150px 75px 150px;
    border-radius: 8px;
    margin-top: 15px;
  }
  .dashedbtn_download {
    background: #349eab !important;
    border-radius: 0px;
    padding: 12px 65px 12px 45px;
    font-size: 12px;
  }
  .text_center {
    display: flex;
    gap: 80px;
  }
`;

const FuelEntryAI = () => {
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const AIVehicleLists = useSelector(
    (state) => state?.authTracking?.AIVehicleLists,
  );
  const vehicleLists = useSelector(
    (state) => state?.authTracking?.vehicleLists,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const [form] = Form.useForm();
  const [filterform] = Form.useForm();
  const allValues = filterform.getFieldsValue();

  const [filterData, setFilterData] = useState({
    duration: "current_month",
    daterange: [moment().startOf("month"), moment().endOf("month")],
  });
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const createAllowed = useMemo(
    () => hasPermission("FUELAI", "CRF"),
    [reduxPermissions],
  );
  const updateAllowed = useMemo(
    () => hasPermission("FUELAI", "UPF"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("FUELAI", "DEF"),
    [reduxPermissions],
  );
  const importAllowed = useMemo(
    () => hasPermission("FUELAI", "FIM"),
    [reduxPermissions],
  );
  const exportAllowed = useMemo(
    () => hasPermission("FUELAI", "FEX"),
    [reduxPermissions],
  );

  useEffect(
    () => {
      if (filterform.getFieldValue("duration") === "last_month") {
        filterform.setFieldValue("daterange", [
          moment().subtract(1, "months").startOf("month"),
          moment().subtract(1, "months").endOf("month"),
        ]);
        setFilterData((PrevValue) => ({
          ...PrevValue,
          ["daterange"]: [
            dayjs().subtract(1, "month").startOf("month"),
            dayjs().subtract(1, "month").endOf("month"),
          ],
        }));
      } else if (filterform.getFieldValue("duration") === "current_month") {
        filterform.setFieldValue("daterange", [
          moment().startOf("month"),
          moment().endOf("month"),
        ]);
        setFilterData((PrevValue) => ({
          ...PrevValue,
          ["daterange"]: [dayjs().startOf("month"), dayjs().endOf("month")],
        }));
      } else if (filterform.getFieldValue("duration") === "current_year") {
        filterform.setFieldValue("daterange", [
          moment().startOf("year"),
          moment().endOf("year"),
        ]);
        setFilterData((PrevValue) => ({
          ...PrevValue,
          ["daterange"]: [dayjs().startOf("year"), dayjs().endOf("year")],
        }));
      } else if (filterform.getFieldValue("duration") === "today") {
        filterform.setFieldValue("daterange", [moment(), moment()]);

        setFilterData((PrevValue) => ({
          ...PrevValue,
          ["daterange"]: [dayjs(), dayjs()],
        }));
      } else if (filterform.getFieldValue("duration") === "---") {
        filterform.setFieldValue("daterange", [null, null]);
        setFilterData((PrevValue) => ({
          ...PrevValue,
          ["daterange"]: [null, null],
        }));
      }
    },
    //  [filterData?.duration]
    [filterform.getFieldValue("duration"), filterData?.duration],
  );

  // useEffect(() => {
  //   if (filterform.getFieldValue("duration") === "last_month") {
  //     filterform.setFieldValue("daterange", [
  //       moment().subtract(1, "months").startOf("month"),
  //       moment().subtract(1, "months").endOf("month"),
  //     ]);
  //     setFilterData((prevValue) => ({
  //       ...prevValue,
  //     }));
  //   } else if (filterform.getFieldValue("duration") === "current_month") {
  //     filterform.setFieldValue("daterange", [
  //       moment().startOf("month"),
  //       moment().endOf("month"),
  //     ]);
  //   } else if (filterform.getFieldValue("duration") === "current_year") {
  //     filterform.setFieldValue("daterange", [
  //       moment().startOf("year"),
  //       moment().endOf("year"),
  //     ]);
  //   } else if (filterform.getFieldValue("duration") === "today") {
  //     filterform.setFieldValue("daterange", [moment(), moment()]);
  //   } else if (filterform.getFieldValue("duration") === "---") {
  //     filterform.setFieldValue("daterange", [null, null]);
  //   }
  // }, [filterform.getFieldValue("duration")]);

  const [visibleExport, setVisibleExport] = useState(false);
  const [visibleImport, setVisibleImport] = useState(false);
  const [visibleSort, setVisibleSort] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [customFields, setCustomFields] = useState([]);
  const [popupMessage, setPopupMessage] = useState(null); // To store the message
  const [isPopupVisible, setIsPopupVisible] = useState(false); // To control popup visibility
  const [popupMessage1, setPopupMessage1] = useState(null); // To store the message
  const [isPopupVisible1, setIsPopupVisible1] = useState(false); // To control popup visibility
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);
  const handleUpload = async (file) => {
    const formData = new FormData();
    formData.append("file", file); // 'file' is the key your backend will expect
    try {
      setLoading(true);
      const response = await axios.post(
        "https://7gyutppcwl.execute-api.us-east-1.amazonaws.com/Prod/aifuel/importExcel",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: window?.localStorage?.getItem("token") || "",
          },
        },
      );
      if (response?.data?.data?.successCount > 0) {
        message.success(response?.data?.data?.message);
        setModalforimport(false);
        fetchFuelEntrytData();
      } else {
        const errorString = response?.data?.data?.errors || "Import failed";
        const errorList = errorString
          ? errorString.split("\n")
          : ["Import failed"];
        setModalforimport(false);
        setPopupMessage1(errorList);
        setIsPopupVisible1(true);
        setLoading(false);
        return; // Exit early
      }
    } catch (error) {
      console.error("Upload error:", error);
      message.error("Something went wrong during upload.");
    } finally {
      setLoading(false);
    }
    return false;
  };

  const handleTooltipVisibleChangeExport = (visible) => {
    setVisibleExport(visible);
    hideTooltipArrow();
  };

  const handleTooltipVisibleChangeImport = (visible) => {
    setVisibleImport(visible);
    hideTooltipArrow();
  };

  const handleTooltipVisibleChangeSort = (visible) => {
    setVisibleSort(visible);
    hideTooltipArrow();
  };

  const hideTooltipArrow = () => {
    setTimeout(() => {
      const tooltipArrows = document.querySelectorAll(".ant-tooltip-arrow");
      tooltipArrows.forEach((arrow) => {
        arrow.style.display = "none";
      });
    }, 0);
  };

  //sorting functionality

  const [consignee, setConsignee] = useState(false);
  const [hoveredrow, setHoveredrow] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [fuelData, setFuelData] = useState([]);
  const [fuelId, setFuelId] = useState("");
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    vehicle: "",
    fueldate: "",
    litres: "",
    price: "",
    odoreading: "",
    fueltext: "",
    transporter: "",
    StationName: "",
    Milage: "",
    FUELID: "",
    CRBY: "",
    CRON: "",
  });

  const [addEditFormData, setAddEditFormData] = useState({
    vehicle: "",
    fueldate: "",
    litres: "",
    price: "",
    odoreading: "",
    fueltext: "",
    transporter: "",
  });

  const [CSVList, setCSVList] = useState([]);
  const [CSVList1, setCSVList1] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const csvLinkEl = useRef(null);
  const csvLinkEl2 = useRef(null);

  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  //custome data Get All function
  const [AllCustomeData, SetAllCustomeData] = useState([]);
  const [customDataLoaded, setCustomDataLoaded] = useState(false);

  const GetAllCustomeData = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "GET",
        `mastertable/GetAllCustomeData?MCID=${userInfo?.MCID}&REFTAB=AIFuel`,
      );
      SetAllCustomeData(data);
      setCustomDataLoaded(true);
    } catch (error) {
      console.error("Error fetching custom data", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchFuelEntrytData = async () => {
    setLoading(true);

    const { data } = await CALL_API("POST", `aifuel/getAllAIFuelDetails`, {
      mcId: userInfo?.MCID,
      vehid: filterData?.vehicle || "",
      fullNm: filterData?.driver || "",
      supName: filterData?.transporter || "",
      dateFrom: filterform?.getFieldValue("daterange")
        ? dayjs(filterform?.getFieldValue("daterange")?.[0])?.format(
            "YYYY-MM-DD",
          )
        : dayjs().startOf("month"),
      dateTo: filterform?.getFieldValue("daterange")
        ? dayjs(filterform?.getFieldValue("daterange")?.[1])?.format(
            "YYYY-MM-DD",
          )
        : dayjs().endOf("month"),
      pageSize: pageSize,
      page: currentPage,
    });

    const customData = Array.isArray(AllCustomeData) ? AllCustomeData : [];

    const newData1 = data?.data?.map((fuelItem) => {
      const enrichedItem = { ...fuelItem };

      // Match custom rows by REFID === FUELID
      const matchedFields =
        customData.filter(
          (field) =>
            Number(field.REFID) === Number(fuelItem.FUELID) &&
            field.CFID != null,
        ) || [];

      matchedFields.forEach((field) => {
        enrichedItem[field.CFID] = field.VALUE;
      });

      return enrichedItem;
    });
    GetAllCustomeData();
    setFuelData(newData1 || []);
    setLoading(false);
    setTotal(data?.total || 0);
  };
  const [selectedColumns, setSelectedColumns] = useState([]);

  //export functionality
  const CSV = async (event, done) => {
    try {
      setCSVLoader(true);

      const { data } = await CALL_API("POST", `aifuel/getAllAIFuelDetails`, {
        mcId: userInfo?.MCID,
        vehid: filterData?.vehicle || "",
        fullNm: filterData?.driver || "",
        supName: filterData?.transporter || "",
        dateFrom: filterform?.getFieldValue("daterange")
          ? dayjs(filterform?.getFieldValue("daterange")?.[0])?.format(
              "YYYY-MM-DD",
            )
          : dayjs().startOf("month"),
        dateTo: filterform?.getFieldValue("daterange")
          ? dayjs(filterform?.getFieldValue("daterange")?.[1])?.format(
              "YYYY-MM-DD",
            )
          : dayjs().endOf("month"),
        pageSize: total,
        page: 1,
      });

      const fuelData = data?.data || [];
      const customFieldMap = {};
      (Array.isArray(customFields) ? customFields : []).forEach((cf) => {
        if (cf.CFID) {
          customFieldMap[cf.CFID] = cf.FIELDNAME || cf.FIELDCODE;
        }
      });
      const enrichedData = fuelData.map((item) => {
        const matchedFields =
          (Array.isArray(AllCustomeData) ? AllCustomeData : []).filter(
            (f) => f.REFID === item.FUELID,
          ) || [];

        // Build custom field-value map with readable names
        const customFieldValues = {};

        // Ensure every custom field exists
        (Array.isArray(customFields) ? customFields : []).forEach((cf) => {
          const fieldName = customFieldMap[cf.CFID] || `Custom_${cf.CFID}`;

          const matched = matchedFields.find((f) => f.CFID === cf.CFID);

          customFieldValues[fieldName] = matched?.VALUE || "-";
        });

        // Merge base and custom data for export
        return {
          Vehicle: item.RegNo || "-",
          "Fuel Date": item.FUELDATE
            ? dayjs(item.FUELDATE).format("DD/MM/YYYY")
            : "-",
          "Litres Fueled": item.QTY || "-",
          "Price Per Litre": item.RATE || "-",
          Amount: item.AMOUNT != null ? Number(item.AMOUNT).toFixed(2) : "-",
          "ODO Reading": item.ODOREADING || "-",
          Mileage: item.MILAGE || "0",
          Transporter: item.SupName || "-",
          "Created By": item.FULLNM || "-",
          ...customFieldValues,
        };
      });

      // Export if data exists
      if (enrichedData.length > 0) {
        setCSVList(enrichedData);
        setTimeout(() => csvLinkEl.current.link.click(), 500);
      } else {
        message.error("No data available to download.");
      }

      setCSVLoader(false);
    } catch (error) {
      setCSVLoader(false);
      console.error("[prepareCSV] error -->", error);
    }
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    setFormData((PrevValue) => ({ ...PrevValue, [name]: value }));
  };
  const handleFilterChange = (e) => {
    const { value, name } = e.target;

    setFilterData((PrevValue) => ({ ...PrevValue, [name]: value }));
  };
  const [isEditing, setIsEditing] = useState(false);
  const showDrawer = () => {
    setIsEditing(false);
    setFormData({
      vehicle: "",
      fueldate: "",
      litres: "",
      price: "",
      odoreading: "",
      fueltext: "",
      transporter: "",
      StationName: "",
      Milage: "",
      FUELID: "",
      CRBY: "",
      CRON: "",
    });
    setDrawerOpen(true);
  };

  const editUser = (record) => {
    setIsEditing(true);
    setFormData(record);
    setDrawerOpen(true);
    loadCustomFields();
  };

  const handleClickme = (record) => {
    setHoveredrow(record?.key);
  };

  useEffect(() => {
    fetchFuelEntrytData();

    const count = Object.values(filterData).filter(
      (val) => val && val.length !== 0,
    ).length;
    setFilterCount(count);
  }, [filterData, currentPage, pageSize]);

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const [showModal, SetshowModal] = useState(false);

  const [resolveModal, setResolveModal] = useState(false);

  const handleclickme = () => {
    SetshowModal(true);
  };

  const handlecancelmodal = () => {
    SetshowModal(false);
  };

  const closeEditModal = () => {
    setResolveModal(false);
  };
  const editModuleupdate = () => {
    // form.resetFields();
    filterform.resetFields();

    setFilterData({
      duration: "current_month",
      daterange: [dayjs(), dayjs()],
    });
  };
  const [sortFields, setSortFields] = useState([]);

  const [formType, setFormType] = useState("addEdit"); // 'addEdit' or 'bulkCreate'
  const [selectedFileId, setSelectedFileId] = useState(null);

  const handleCreateClick = () => {
    setFormType("addEdit");
    setDrawerOpen(true);
    loadCustomFields();
  };

  const handleClose = () => {
    setDrawerOpen(false);
  };

  const handleSelectChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };

  const handleFilterSelectChange = (field, value) => {
    setFilterData((prevData) => ({
      ...prevData,
      [value]: field,
    }));
  };

  const handleCancel = () => {
    form.resetFields();
    setIsEditing(false);
    setDrawerOpen(false);

    setFormData({
      vehicle: "",
      fueldate: "",
      litres: "",
      price: "",
      odoreading: "",
      fueltext: "",
      transporter: "",
      StationName: "",
      Milage: "",
      FUELID: "",
      CRBY: "",
      CRON: "",
    });
  };

  const handleDelete = async (fuelId, deleteType="singleDelete") => {
    try {
      let payload ={};
      if(deleteType === "bulkDelete"){
        payload.fuelIds = selectedRows;
      } else {
        payload.fuelId = fuelId;
      }
      // 1. Delete the fuel entry
      await CALL_API("Delete", `aiFuel/deleteAIfuel`, payload);

      // 2. Delete all custom fields for this fuel entry
      await CustomeDataDelete(fuelId, deleteType); // Pass null for cfId to delete all for this fuel entry
      message.success(deleteType === "bulkDelete" ? "Selected fuel entries deleted successfully" : "Fuel entry deleted successfully");
      GetAllCustomeData();
      fetchFuelEntrytData();
      setIsDeleteModalVisible(false);
      setOpenConfirmDeleteModal(false);
      setSelectedRows([]);
      setSelectAll(false);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  //Custome Field api calling Function

  const loadCustomFields = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "AIFuel",
        RefId: 0,
        Active: 1,
        McId: userInfo?.MCID,
      });
      setCustomFields(data);
    } catch (error) {
      setCustomFields();
      console.error("Error fetching custom fields:", error);
    } finally {
      setLoading(false);
    }
  };
  //custome data creat api call functionality
  const [CreateCustomeData, setCreateCustomeData] = useState([]);

  const CustomeDataCreate = async (fuelId) => {
    try {
      const customDataList = customFields
        ?.map((field) => {
          const fieldName = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
          const value = formData?.[fieldName];
          if (value !== undefined && value !== "") {
            return {
              CfId: field.CFID,
              RefId: fuelId,
              Value: value,
            };
          }
          return null;
        })
        .filter(Boolean);

      if (customDataList.length === 0) {
        return;
      }

      const { data } = await CALL_API("POST", "mastertable/CreateCFID", {
        customDataList,
      });

      setCreateCustomeData(data);
    } catch (error) {
      setCreateCustomeData([]);
      console.error("Error creating custom fields:", error);
    }
  };
  //Update custom data api call functionality
  const CustomeDataUpdate = async (fuelId) => {
    setLoading(true);
    try {
      // Loop through all custom fields
      for (const field of customFields) {
        const fieldName = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
        const value = formData?.[fieldName];

        // Find the existing custom data for this field and fuel entry
        const existing = AllCustomeData?.find(
          (item) => item.REFID === fuelId && item.CFID === field.CFID,
        );

        // Only update if value is present and there is an existing record
        if (value !== undefined && value !== "" && existing) {
          const payload = {
            CfId: field.CFID,
            RefId: fuelId,
            Value: value,
            DataId: existing.DATAID,
          };

          await CALL_API("PATCH", "mastertable/updateCustomData", payload);
        }
      }
    } catch (error) {
      console.error("Error updating custom fields:", error);
    } finally {
      setLoading(false);
    }
  };

  //Delete custom data api call functionality
  const CustomeDataDelete = async (refId, type= "singleDelete") => {
    setLoading(true);
    let payload = {
          RefTab: "AIFuel",
          McId: userInfo?.MCID,
        };
    if(type === "bulkDelete"){
      payload.RefIds = refId; // <-- Use RefIds for bulk delete
    }else{
      payload.RefId = refId; // <-- Use refId for single delete
    }
    try {
      const { data } = await CALL_API(
        "DELETE",
        `mastertable/deleteCustomDataByRef`,
        payload
      );
    } catch (error) {
      console.error("Error deleting custom field:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadCustomFields();
  }, []);

  const getFieldType = (type) => {
    const typeMap = {
      1: "select", // DropDown
      2: "text", // TextBox
      3: "checkbox", // CheckBox
    };
    return typeMap[type] || "text";
  };

  const chunkArray = (arr, size = 3) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      const row = arr.slice(i, i + size);
      while (row.length < size) {
        row.push({}); // Empty field to maintain layout
      }
      chunks.push(row);
    }
    return chunks;
  };

  const dynamicCustomColumns = useMemo(() => {
    if (!Array.isArray(customFields) || customFields.length === 0) return [];
    return customFields?.map((field) => ({
      title: field.FIELDNAME,
      dataIndex: field.CFID, // Use CFID for correct mapping!
      key: field.CFID,
      sorter: false,
      render: (text) => text || "-",
    }));
  }, [customFields]);

  // useEffect(() => {
  //   if(customFields.length > 0){

  //     setFuelData(newData);
  //   }
  // }, [customFields])

  const handleSelectAll = (checked) => {
    setSelectAll(checked);
    if (checked) {
      setSelectedRows(fuelData.map((row) => row.FUELID));
    } else {
      setSelectedRows([]);
    }
  };

  const handleRowCheck = (checked, fuelId) => {
    const updated = checked
      ? [...selectedRows, fuelId]
      : selectedRows.filter((id) => id !== fuelId);

    setSelectedRows(updated);
    setSelectAll(updated.length === fuelData.length);
  };
  //Columns for the table
  const columns = [
     {
      title: (
        <CustomCheckbox
          checked={selectAll}
          onChange={(e) => handleSelectAll(e.target.checked)}
          className="fuel-select-all"
        />
      ),
      dataIndex: "checkbox",
      key: "checkbox",
      width: 50,
      render: (_, record) => (
        <CustomCheckbox
          checked={selectedRows.includes(record.FUELID)}
          onChange={(e) => handleRowCheck(e.target.checked, record.FUELID)}
          onClick={(e) => e.stopPropagation()} // prevent row onClick from firing
        />
      ),
    },
    {
      title: "Vehicle",
      dataIndex: "RegNo",
      key: "RegNo",
      sorter: sortFields?.includes("REGNO")
        ? (a, b) => a.RegNo?.localeCompare(b.RegNo)
        : false,
    },
    {
      title: "Fuel Date",
      dataIndex: "FUELDATE",
      key: "FUELDATE",
      render: (value) => dayjs(value).format("DD/MM/YYYY"),
    },
    {
      title: "Litres Fueled",
      dataIndex: "QTY",
      key: "QTY",
      sorter: sortFields?.includes("FuelQty") // remove leading space!
        ? (a, b) => (a.QTY ?? 0) - (b.QTY ?? 0)
        : false,
    },
    {
      title: "Price Per Litre",
      dataIndex: "RATE",
      key: "RATE",
      sorter: sortFields?.includes("RATES")
        ? (a, b) => (a.RATE ?? 0) - (b.RATE ?? 0)
        : false,
    },
    {
      title: "Amount",
      dataIndex: "AMOUNT",
      key: "AMOUNT",
      sorter: sortFields?.includes("Amounts")
        ? (a, b) => (a.AMOUNT ?? 0) - (b.AMOUNT ?? 0)
        : false,
      render: (value) => {
        if (value == null || isNaN(value)) return "-";
        return new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value);
      },
    },
    {
      title: "ODO Reading",
      dataIndex: "ODOREADING",
      key: "ODOREADING",
      sorter: sortFields?.includes("Odoreadings")
        ? (a, b) => (a.ODOREADING ?? 0) - (b.ODOREADING ?? 0)
        : false,
    },
    {
      title: "Mileage",
      dataIndex: "MILAGE",
      key: "MILAGE",
      sorter: sortFields?.includes("Mileage")
        ? (a, b) => (a.MILAGE ?? 0) - (b.MILAGE ?? 0)
        : false,
    },
    {
      title: "Created by",
      dataIndex: "FULLNM",
      key: "FULLNM",
    },
    {
      title: "Transporter",
      dataIndex: "SupName",
      key: "SupName",
      sorter: sortFields?.includes("SupName")
        ? (a, b) => a.SupName?.localeCompare(b.SupName)
        : false,
      render: (text) => text || "-",
    },
    {
      title: "Actions",
      key: "actions",
      width: "15%",
      render: (_, record) => (
        <div
          className={
            hoveredrow === record?.key
              ? "d-flex gap-3 opacity-100"
              : "opacity-0"
          }
        >
          <Tooltip title={!updateAllowed ? "No permission" : ""}>
            <EditIcon
              style={{ cursor: updateAllowed ? "pointer" : "not-allowed" }}
              onClick={(e) => {
                if (!updateAllowed) return;
                e.stopPropagation();
                setDrawerOpen(true);
                setIsEditing(true);
                // Map existing custom field values from the row into formData
                // using the same lowercase FIELDNAME keys used in the form.
                const customFieldValues = {};
                (Array.isArray(customFields) ? customFields : []).forEach(
                  (field) => {
                    const fieldKey = field.FIELDNAME?.replace(
                      /\s+/g,
                      "_",
                    ).toLowerCase();
                    if (!fieldKey) return;
                    const value = record?.[field.CFID];
                    if (value !== undefined) {
                      customFieldValues[fieldKey] = value;
                    }
                  },
                );
                setFormData({
                  FUELID: record?.FUELID,
                  vehicle: record?.VEHID,
                  price: record?.RATE,
                  Milage: record?.MILAGE,
                  fueldate: dayjs(record?.FUELDATE),
                  odoreading: record?.ODOREADING,
                  litres: record?.QTY,
                  CRBY: record?.CRBY,
                  CRON: record?.CRON,
                  StationName: record?.StationName,
                  transporter: record?.SHIPPER,
                  fueltext: "",
                  ...customFieldValues,
                });
              }}
            />
          </Tooltip>
          <Tooltip title={!deleteAllowed ? "No permission" : ""}>
            <DeleteIcon
              style={{
                cursor: deleteAllowed ? "pointer" : "not-allowed",
                marginLeft: "10px",
              }}
              onClick={(e) => {
                if (!deleteAllowed) return;
                e.stopPropagation();
                handleclickdelete(record?.FUELID);
                setSelectedFileId(record?.FUELID);
              }}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  const defaultColumnOptions = columns?.map((col) => ({
    label: col.title,
    value: col.key,
    disabled: true,
  }));

  // Custom fields (selectable)
  const customFieldOptions = Array.isArray(customFields)
    ? customFields?.map((field) => ({
        label: field.FIELDNAME,
        value: field.CFID,
        disabled: false,
      }))
    : [];

  const allColumnOptions = [...customFieldOptions];
  //combained column with custom fields and columns
  const combinedColumns = useMemo(() => {
    if (!customFields || customFields.length === 0) {
      return columns; // Return default columns if no custom fields
    }

    const dynamicCols = customFields?.map((field) => ({
      title: field.FIELDNAME,
      dataIndex: field.CFID, // use CFID; rows are enriched with CFID keys
      key: field.CFID,
      sorter: false,
      render: (_, record) => record?.[field.CFID] ?? "-",
    }));

    return [...dynamicCols];
  }, [customFields]);

  const displayedColumns = useMemo(() => {
    const defaultCols = [...columns];
    const customCols = combinedColumns.filter((col) =>
      selectedColumns.includes(col.key),
    );
    const transporterIdx = defaultCols.findIndex(
      (col) => col.key === "SupName",
    );
    const actionsIdx = defaultCols.findIndex((col) => col.key === "actions");
    const beforeTransporter = defaultCols.slice(0, transporterIdx + 1);
    const afterTransporter = defaultCols.slice(transporterIdx + 1, actionsIdx);
    const actionsCol = defaultCols.slice(actionsIdx);
    return [
      ...beforeTransporter,
      ...customCols,
      ...afterTransporter,
      ...actionsCol,
    ];
  }, [columns, combinedColumns, selectedColumns]);

  const AddEditFormm = useMemo(() => {
    const mappedCustomFields = customFields?.map((field, index) => {
      const name = field.FIELDNAME?.replace(/\s+/g, "_").toLowerCase();
      const mappedField = {
        id: field.CFID,
        label: field.FIELDNAME,
        type: getFieldType(field.FIELDTYPE),
        name: name,
        placeholder: field.FIELDNAME,
        maxLength: field.MAXLEN > 0 ? field.MAXLEN : undefined,
        validationRules: field.REQUIRED
          ? [{ required: true, message: `${field.FIELDNAME} is required` }]
          : [],
      };

      return mappedField;
    });
    const customFieldRows = chunkArray(mappedCustomFields || [], 3);

    const fullForm = {
      pages: [
        {
          colSpan: [
            [6, 6, 6, 6],
            [6, 6, 6, 6],

            ...customFieldRows?.map((row) => row?.map(() => 6)),
          ],
          fields: [
            [
              {
                id: 1,
                label: "Vehicle",
                type: "selectwithvalue",
                name: "vehicle",
                options: AIVehicleLists?.map((item) => ({
                  value: item?.FGUID,
                  label: item?.FVehicleName,
                })),
                validationRules: [
                  { required: true, message: "Vehicle is required" },
                ],
                maxLength: 50,
              },
              {
                id: 2,
                label: "Fuel Date",
                type: "date",
                showtime: true,
                format: "YYYY-MM-DD HH:mm:ss",
                name: "fueldate",
                placeholder: "24th Aug 2024; 07:10 AM",
                style: "",
                validationRules: [
                  { required: true, message: "Fuel Date is required" },
                ],
              },
              {
                id: 3,
                label: "Litres Fueled",
                type: "text",
                name: "litres",
                placeholder: "40",
                style: "",
                validationRules: [
                  { required: true, message: "Litres Fueled is required" },
                ],
              },
              {
                id: 4,
                label: "Price per Litre",
                type: "text",
                name: "price",
                style: "",
                validationRules: [
                  { required: true, message: "Price per Litre is required" },
                ],
              },
            ],
            [
              {
                id: 5,
                label: "ODO Reading",
                type: "text",
                name: "odoreading",
                style: "",
                validationRules: [
                  { required: true, message: "ODO Reading is required" },
                ],
              },
              {
                id: 6,
                label: "Station Name",
                type: "text",
                name: "StationName",
                style: "",
              },
              {
                id: 7,
                label: "Transporter",
                type: "selectwithvalue",
                name: "transporter",
                placeholder: "Cargo",
                options: transporterList?.map((item) => ({
                  value: item?.ID,
                  label: item?.Name,
                })),
                style: "",
                validationRules: [
                  { required: false, message: "Transporter is required" },
                ],
              },
              {},
              {},
            ],

            ...customFieldRows,
          ],
        },
      ],
    };
    return fullForm;
  }, [vehicleLists, customFields, formData]);

  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
    { label: "---", value: "---" },
  ];

  const ModalForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [6],
        fields: [
          [
            {
              id: 1,
              label: <span style={{ color: "#5F6D8C" }}>Vehicle</span>,
              type: "selectwithvalue",
              name: "vehicle",
              placeholder: "KA23134",
              maxLength: 50,
              options: AIVehicleLists?.map((item) => ({
                value: item?.FGUID,
                label: item?.FVehicleName,
              })),
            },
            {
              id: 2,
              label: <span style={{ color: "#5F6D8C" }}>Driver</span>,
              type: "selectwithvalue",
              name: "driver",
              placeholder: "Thomas",
              maxLength: 50,
              options: AIVehicleLists?.filter((item) => item?.FDriverName) // only include items with driver name
                ?.map((item) => ({
                  value: item?.FDriverName,
                  label: item?.FDriverName,
                })),
            },
            {
              id: 3,
              label: <span style={{ color: "#5F6D8C" }}>Duration</span>,
              type: "selectwithvalue",
              name: "duration",
              initialValues: "current_month",
              placeholder: "Current Month",
              maxLength: 50,
              options: Duration?.map((item) => ({
                label: item.label,
                value: item.value,
              })),
            },
            {
              id: 4,
              label: <span style={{ color: "#5F6D8C" }}>Date Range</span>,
              type: "daterange",
              name: "daterange",
              placeholder: ["Start Date", "End Date"],
            },
          ],
          [
            {
              id: 5,
              label: <span style={{ color: "#5F6D8C" }}>Transporter</span>,
              type: "selectwithvalue",
              name: "transporter",
              placeholder: "Cargo",
              maxLength: 50,
              options: transporterList?.map((item) => ({
                label: item.Name,
                value: item.Name,
              })),
            },
            {},
            {},
            {},
          ],
        ],
      },
    ],
  };

  const handleSubmitForm = async (values) => {
    try {
      setLoading(true);

      const editPayload = {
        fuelId: formData?.FUELID,
        vehId: formData?.vehicle,
        fuelDate: formData?.fueldate,
        odoReading: Number(formData?.odoreading),
        qty: Number(formData?.litres),
        rate: Number(formData?.price),
        stationName: formData?.StationName,
        transporter: formData?.transporter,
        REGNO: AIVehicleLists?.find((v) => v.FGUID === formData?.vehicle)?.FVehicleName,
      };
      // const odoReading = Number(formData?.odoreading);
      //   const litres = Number(formData?.litres);
      //   const mileage = litres ? (odoReading / litres).toFixed(2) : 0;
      const payload = {
        vehId: formData?.vehicle,
        fuelDate: formData?.fueldate,
        odoReading: Number(formData?.odoreading),
        qty: Number(formData?.litres),
        rate: Number(formData?.price),
        stationName: formData?.StationName || "",
        crBy: userInfo?.UID,
        crOn: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        Shipper: formData?.transporter,
        REGNO: AIVehicleLists?.find((v) => v.FGUID === formData?.vehicle)?.FVehicleName,
      };

      const { data, ResponseCode } = await CALL_API(
        isEditing ? "PATCH" : "POST",
        isEditing ? `aifuel/editfuelDetail` : `aifuel/create/savefuel`,
        isEditing ? editPayload : payload,
      );
      // Custom field logic
      const fuelId = isEditing ? formData?.FUELID : data?.fuelId; // Get from existing or response

      // Create or update custom fields
      if (fuelId) {
        if (!isEditing) {
          await CustomeDataCreate(fuelId);
        } else {
          await CustomeDataUpdate(fuelId);
        }
      }

      // FILE UPLOAD (only after creation)
      if (!isEditing && formData?.files?.length) {
        for (const file of formData.files) {
          const reader = new FileReader();
          reader.onload = async () => {
            const base64 = reader.result;
            const payload = {
              title: file.name,
              fileSize: file.size,
              mimeType: 1,
              crBy: userInfo?.UID,
              attKey: "testKey",
              refTab: "AIFUEL",
              refId: fuelId,
              lat: "",
              lng: "",
              crOn: new Date(),
              fileName: file.name,
              fileType: file.name.split(".").pop(),
              file: base64,
              BASE: base64.split(",")[1],
            };
            await CALL_API("POST", "common/file/addFile", payload);
          };
          reader.readAsDataURL(file);
        }
      }
      // Handle known validation errors
      if (ResponseCode === 400) {
        const errorMessage = data?.data?.message || data?.message;

        if (errorMessage.includes("Fuel date")) {
          setPopupMessage(errorMessage);
          setIsPopupVisible(true);
          setLoading(false);
          return; // Exit early
        }

        if (errorMessage.includes("ODO")) {
          setPopupMessage(errorMessage);
          setIsPopupVisible(true);
          setLoading(false);
          return; // Exit early
        }

        // Handle other 400 errors
        message.error(
          errorMessage || "Bad request, please check your parameters.",
        );
        setLoading(false);
        return; // Exit early
      }

      // Refresh custom data first, then reload table with the fresh custom values
      await GetAllCustomeData();
      await fetchFuelEntrytData();

      message.success(
        isEditing ? "Fuel updated successfully" : "Fuel created successfully",
      );

      handleCancel();
      setLoading(false);
    } catch (error) {
      console.error("[handleSubmitForm] error -->", error);
      setLoading(false);
    }
  };

  //Sorting functionality on triggering the sort icon
  const [checkedList, setCheckedList] = useState([]);

  const onCheckAllChange = (e) => {
    const isChecked = e.target.checked;
    setSortFields(isChecked ? allOptions : []);
  };

  const allOptions = [
    "SupName",
    "Odoreadings",
    "Mileage",
    "Amounts",
    "RATES",
    "FuelQty",
    "REGNO",
  ];
  const handleSortOptionsChange = (checkedValues) => {
    setSortFields(checkedValues);
  };
  const content = (
    <WrapperBox>
      <div className="checkbox_group_container">
        <Checkbox
          indeterminate={
            sortFields.length > 0 && sortFields.length < allOptions.length
          }
          onChange={onCheckAllChange}
          checked={sortFields.length === allOptions.length}
        >
          All
        </Checkbox>

        <Checkbox.Group value={sortFields} onChange={handleSortOptionsChange}>
          <div className="checkbox_group_container">
            <Checkbox value="Amounts">Amount</Checkbox>
            <Checkbox value="RATES">Price Per liter</Checkbox>
            <Checkbox value="Odoreadings">Odo Readings</Checkbox>
            <Checkbox value="Mileage">Mileage</Checkbox>
            <Checkbox value="REGNO">Vehicle</Checkbox>
            <Checkbox value="FuelQty">Fuel</Checkbox>
            <Checkbox value="SupName">Transporter</Checkbox>
          </div>
        </Checkbox.Group>
      </div>
    </WrapperBox>
  );

  useEffect(() => {
    GetAllCustomeData();
  }, []);

  useEffect(() => {
    if (customDataLoaded) {
      fetchFuelEntrytData();
    }
  }, [customDataLoaded, currentPage, pageSize]);

  const [isconfigModalVisible, setIsconfigModalVisible] = useState(false);
  const [configId, setconfigId] = useState(null); // To store the ID of the consignment to delete

  const handleclickconfig = (id) => {
    setIsconfigModalVisible(true);
  };

  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null); // To store the ID of the consignment to delete

  const handleclickdelete = (id) => {
    setIsDeleteModalVisible(true);
  };

  const handleopen = () => {};

  const [modalforimport, setModalforimport] = useState(false);

  const handleimportpopupopen = (e) => {
    setModalforimport(true);
  };

  const cancelformodalstyle = (e) => {
    setModalforimport(false);
  };

  const handleDownloadSampleFile = () => {
    // Convert dataSource1 into flat export format
    const exportData = dataSource1?.map((item) => ({
      "S.No": item.key,
      "Vehicle Reg No": item.vehicle,
      "Fuel Date": item.fuelDate,
      Qty: item.litresFueled,
      Rate: item.pricePerLitre,
      ODO: item.odoReading,
      "Station Name": item.stationName,
      Transporter: item.transporter,
    }));

    // Create worksheet
    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Convert worksheet → CSV
    const csvData = XLSX.utils.sheet_to_csv(worksheet);

    // Create Blob
    const fileData = new Blob([csvData], {
      type: "text/csv;charset=utf-8;",
    });

    // Trigger download
    saveAs(fileData, "FuelDataSample.csv");
  };

  const dataSource1 = [
    {
      key: "1",
      vehicle: "KA1234532",
      fuelDate: "07/01/2026",
      litresFueled: "7.00",
      pricePerLitre: "50.00",
      odoReading: "160",
      stationName: "TQS Agency",
      transporter: "ABC Transport",
    },
    {
      key: "2",
      vehicle: "KA1234532",
      fuelDate: "08/01/2026",
      litresFueled: "8.00",
      pricePerLitre: "70.00",
      odoReading: "160",
      stationName: "TQS Agency",
      transporter: "ABC Transport",
    },
    {
      key: "3",
      vehicle: "KA1234532",
      fuelDate: "09/01/2026",
      litresFueled: "40.00",
      pricePerLitre: "90.00",
      odoReading: "160",
      stationName: "TQS Agency",
      transporter: "ABC Transport",
    },
  ];
  const loadingText = ["", ".", "..", "..."];
  const [dotIndex, setDotIndex] = useState(0);

  useEffect(() => {
    if (!loading) return;
    const interval = setInterval(() => {
      setDotIndex((i) => (i + 1) % loadingText.length);
    }, 500);
    return () => clearInterval(interval);
  }, [loading]);
  return (
    <>
      <UIModal
        className="import_modal"
        width={750}
        open={modalforimport}
        onClose={() => {
          setModalforimport(false);
        }}
        closeButton={false}
        size="lg"
        header={false}
        footer={false}
      >
        <WrapperBox>
          <Spin spinning={loading}>
            <Tooltip
              title=""
              placement="bottom"
              visible={visibleImport}
              onVisibleChange={handleTooltipVisibleChangeImport}
              overlayInnerStyle={{
                backgroundColor: "transparent",
                color: "#5f6d8c",
                boxShadow: "none",
                padding: "0",
              }}
            >
              <Upload
                beforeUpload={handleUpload}
                showUploadList={false}
                accept=".csv"
              >
                <ButtonOutlined className="dashedbtn">
                  Drop files here or Click to select files
                </ButtonOutlined>
              </Upload>
            </Tooltip>
          </Spin>
          <hr />

          <div className="text_center">
            <div className="text_center">
              <WideButton onClick={handleDownloadSampleFile}>
                <Tooltip
                  title="Export"
                  placement="bottom"
                  // visible={visibleExport}
                  // onVisibleChange={handleTooltipVisibleChangeExport}
                  overlayInnerStyle={{
                    backgroundColor: "transparent",
                    color: "#5f6d8c",
                    boxShadow: "none",
                    padding: "0",
                  }}
                ></Tooltip>
                Sample file download
              </WideButton>
              <ButtonFilled>Upload</ButtonFilled>
              <ButtonFilled onClick={cancelformodalstyle}>Cancel </ButtonFilled>
            </div>
          </div>
        </WrapperBox>
      </UIModal>
      <Modal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Alert />
            <span>Error</span>
          </div>
        }
        visible={isPopupVisible1}
        height={600}
        width={600}
        onOk={() => setIsPopupVisible1(false)} // Close the popup when "OK" is clicked
        onCancel={() => setIsPopupVisible1(false)} // Allow closing with the "X" button
        footer={[
          <ButtonFilled key="ok" onClick={() => setIsPopupVisible1(false)}>
            OK
          </ButtonFilled>,
        ]}
      >
        <p style={{ fontSize: "15px" }}>
          {
            <ul>
              {popupMessage1?.map((msg, index) => (
                <li key={index}>{msg}</li>
              ))}
            </ul>
          }
        </p>
      </Modal>
      <UIModal
        width={600}
        height={600}
        open={isconfigModalVisible}
        onClose={() => {
          setIsconfigModalVisible(false);
        }}
        closeButton={false}
        size="md"
        header={
          <div className="text-start">
            <h2>Customized Column</h2>
            <label
              style={{ marginBottom: 8, display: "block", color: "#5F6D8C" }}
            >
              Columns
            </label>
          </div>
        }
        footer={
          <div className="mt-2 w-100 d-flex justify-content-end">
            <ButtonFilled
              onClick={() => {
                setIsconfigModalVisible(false); // Close the modal
                GetAllCustomeData();
                fetchFuelEntrytData();
              }}
            >
              Save
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsconfigModalVisible(false); // Just close the modal
              }}
            >
              Cancel
            </Buttontransparent>
          </div>
        }
      >
        <Select
          mode="multiple"
          style={{ width: "100%" }}
          placeholder="Select custom columns"
          value={selectedColumns}
          onChange={setSelectedColumns}
          dropdownStyle={{ maxHeight: 250, overflow: "auto" }}
          dropdownRender={(menu) => (
            <div>
              <Checkbox.Group
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  padding: "8px 12px",
                }}
                value={selectedColumns}
                onChange={setSelectedColumns}
              >
                {allColumnOptions?.map((option) => (
                  <Checkbox
                    key={option.value}
                    value={option.value}
                    disabled={option.disabled}
                  >
                    {option.label}
                  </Checkbox>
                ))}
              </Checkbox.Group>
            </div>
          )}
        >
          {allColumnOptions?.map((option) => (
            <Select.Option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </Select.Option>
          ))}
        </Select>
      </UIModal>

      <UIModal
        width={500}
        open={isDeleteModalVisible}
        onClose={() => {
          setIsDeleteModalVisible(false);
        }}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to delete this?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled
              onClick={() => {
                setIsDeleteModalVisible(false); // Close the modal
                handleDelete(selectedFileId); // Call delete function
              }}
            >
              Yes
            </ButtonFilled>
            <Buttontransparent
              onClick={() => {
                setIsDeleteModalVisible(false); // Just close the modal
              }}
            >
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>

      <UIModal
        width={1200}
        open={showModal}
        onClose={handlecancelmodal}
        closeButton={false}
        size="lg"
        header={
          <WrapperBox>
            <Row>
              <Col xl={24} sm={24}>
                <div className="modal_container_forfiltermenu">
                  <span className="flilter_five">
                    Filters({filterCount || 0}){" "}
                  </span>
                  <span
                    style={{
                      color: "#2C963D",
                      fontWeight: "400",
                      fontSize: "20px",
                    }}
                  ></span>
                </div>
              </Col>
            </Row>
          </WrapperBox>
        }
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <ButtonFilled onClick={editModuleupdate}>Clear All</ButtonFilled>
          </div>
        }
      >
        {/* This is the BODY section of the Modal */}
        <WrapperBox>
          <GridBuilder
            formStructureJson={ModalForm}
            handleChange={handleFilterChange}
            formSubmit={handleSubmitForm}
            initialValues={filterData}
            handleSelectChange={handleFilterSelectChange}
            form={filterform}
          />
        </WrapperBox>
      </UIModal>

      {consignee ? (
        <>
          <FuelDetails
            setDrawerOpen={setDrawerOpen}
            setConsignee={setConsignee}
            AddEditFormm={AddEditFormm}
            handleChange={handleChange}
            handleSubmitForm={handleSubmitForm}
            handleClose={handleClose}
            drawerOpen={drawerOpen}
            formData={formData}
            WrapperBox={WrapperBox}
            setFuelId={setFuelId}
            fuelId={fuelId}
            setIsEditing={setIsEditing}
            setFormData={setFormData}
            handleDelete={handleDelete}
          />
        </>
      ) : (
        <>
          <WrapperBox>
            <Row gutter={16}>
              <Col xs={24} xl={24}>
                <Row gutter={16}>
                  <Col xs={24} xl={24}></Col>
                </Row>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} xl={24}>
                <div className="consingment_container">
                  <p>{total} Fuel Entry</p>
                  <div className="consingment_container_two">
                    <div className="Custom">
                      <Tooltip
                        title={!exportAllowed ? "No permission" : "Export"}
                        placement="bottom"
                        // visible={visibleExport}
                        // onVisibleChange={handleTooltipVisibleChangeExport}
                        overlayInnerStyle={{
                          backgroundColor: "transparent",
                          color: "#5f6d8c",
                          boxShadow: "none",
                          padding: "0",
                        }}
                      >
                        <Spin spinning={CSVLoader}>
                          <img
                            src={ExportIcon}
                            alt="Export"
                            style={{
                              width: "20px",
                              height: "20px",
                              cursor: exportAllowed ? "pointer" : "not-allowed",
                              marginRight: "40px",
                              backgroundColor: "#EBF7ED",
                              borderRadius: "6px",
                            }}
                            onClick={() => {
                              if (!exportAllowed) return;
                              CSV();
                            }}
                          />
                        </Spin>
                        <CSVLink
                          data={CSVList}
                          filename={"FuelEntry.csv"}
                          // asyncOnClick={true}
                          ref={csvLinkEl}
                        />
                      </Tooltip>
                    </div>
                    <div className="Custom">
                      <Tooltip
                        title={!importAllowed ? "No permission" : "Import"}
                        placement="bottom"
                        visible={visibleImport}
                        onVisibleChange={handleTooltipVisibleChangeImport}
                        overlayInnerStyle={{
                          backgroundColor: "transparent",
                          color: "#5f6d8c",
                          boxShadow: "none",
                          padding: "0",
                        }}
                        onClick={handleimportpopupopen}
                      >
                        {/* <Upload
                          beforeUpload={handleUpload}
                          showUploadList={false}
                          accept=".csv"
                        > */}
                        <img
                          src={ImportIcon}
                          alt="Import"
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: importAllowed ? "pointer" : "not-allowed",
                            marginRight: "40px",
                            backgroundColor: "#EBF7ED",
                            borderRadius: "6px",
                          }}
                          onClick={() => {
                            if (!importAllowed) return;
                            handleimportpopupopen();
                          }}
                        />
                        {/* </Upload> */}
                      </Tooltip>
                    </div>
                    <div className="Custom">
                      <Tooltip
                        title="Sort Column"
                        placement="bottom"
                        visible={visibleSort}
                        onVisibleChange={handleTooltipVisibleChangeSort}
                        overlayInnerStyle={{
                          backgroundColor: "transparent",
                          color: "#5f6d8c",
                          boxShadow: "none",
                          padding: "0",
                        }}
                      >
                        <Popover content={content} trigger="click">
                          <img
                            src={SortIcon}
                            alt="Sort"
                            style={{
                              width: "20px",
                              height: "25px",
                              cursor: "pointer",
                              marginRight: "30px",
                              backgroundColor: "#EBF7ED",
                              borderRadius: "6px",
                            }}
                            onClick={(e) => e.preventDefault()}
                          />
                        </Popover>
                      </Tooltip>
                    </div>
                    <Badge
                      count={filterCount}
                      className="badg"
                      style={{ marginRight: "20px" }}
                    >
                      <Avatar
                        shape="circle"
                        size="small"
                        src={FilterIcon}
                        className="filterstyle"
                        onClick={handleclickme}
                        style={{ marginRight: "20px" }}
                      />
                    </Badge>
                    <ButtonOutlined
                      onClick={() => setIsconfigModalVisible(true)}
                      className="Create_btn"
                    >
                      Configure
                    </ButtonOutlined>
                    <Tooltip title={!createAllowed ? "No permission" : ""}>
                      <ButtonFilled
                        onClick={() => {
                          if (!createAllowed) return;
                          handleCreateClick();
                        }}
                        style={{
                          cursor: createAllowed ? "pointer" : "not-allowed",
                        }}
                        className="Create_btn"
                      >
                        + Create
                      </ButtonFilled>
                    </Tooltip>
                  </div>
                </div>
              </Col>
            </Row>
          </WrapperBox>

          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div>
                <Spin spinning={loading}>
                  {fuelData.length > 0 && (
                    <StyledTable
                      className=""
                      pagination={false}
                      dataSource={fuelData}
                      columns={displayedColumns}
                      onRow={(record) => ({
                        onMouseEnter: () => handleClickme(record),
                        onMouseLeave: () => setHoveredrow(null),
                        onClick: () => {
                          setFuelId(record?.FUELID);
                          setConsignee(true);
                        },
                      })}
                    />
                  )}
                  <ReusablePagination
                    pageSize={pageSize}
                    handlePageSizeChange={handlePageSizeChange}
                    currentPage={currentPage}
                    total={total}
                    handlePageChange={handlePageChange}
                  />
                </Spin>
              </div>
            </Col>
          </Row>
        </>
      )}
     <BulkDeletePopup selectedRows={selectedRows} handleDelete={()=> setOpenConfirmDeleteModal(true)} />
     <ConfirmModal
        open={openConfirmDeleteModal}
        onConfirm={() => handleDelete(selectedRows, "bulkDelete")}
        onCancel={() => setOpenConfirmDeleteModal(false)}
        title="Delete Fuel Entries?"
        description="This action will permanently delete the selected fuel entries. Do you want to proceed?"
        icon= {<DeleteOutlined style={{ fontSize: 24, color: "#e53535" }} />}
        loading={loading}
      />
      <ReusableDrawer
        title=""
        open={drawerOpen}
        setOpen={setDrawerOpen}
        onClose={handleCancel}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Buttontransparent
              key="cancel"
              className="cancel-btn"
              onClick={handleCancel}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Buttontransparent>
            <ButtonFilled
              key="create"
              type="primary"
              loading={loading}
              disabled={loading}
              onClick={() => form.submit()}
            >
              {loading
                ? `${isEditing ? "Updating" : "Creating"}${loadingText[dotIndex]}`
                : isEditing
                  ? "Update"
                  : "Create"}
            </ButtonFilled>
          </div>,
        ]}
      >
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div className="Creating_Consignment">
                <p>
                  {isEditing ? "Modifying Fuel Entry" : "Creating Fuel Entry"}
                </p>

                <span>
                  <CloseOutlined onClick={() => setDrawerOpen(false)} />
                </span>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <GridBuilder
                formStructureJson={AddEditFormm}
                handleChange={handleChange}
                formSubmit={handleSubmitForm}
                initialValues={formData}
                handleSelectChange={handleSelectChange}
                form={form}
              />
            </Col>
          </Row>
        </WrapperBox>
        <Modal
          title={
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Alert />
              <span>Information</span>
            </div>
          }
          visible={isPopupVisible}
          onOk={() => setIsPopupVisible(false)} // Close the popup when "OK" is clicked
          onCancel={() => setIsPopupVisible(false)} // Allow closing with the "X" button
          footer={[
            <ButtonFilled key="ok" onClick={() => setIsPopupVisible(false)}>
              OK
            </ButtonFilled>,
          ]}
        >
          <p style={{ fontSize: "15px" }}>{popupMessage}</p>
        </Modal>
      </ReusableDrawer>
    </>
  );
};

export default FuelEntryAI;
